import { useEffect, useState } from "react";
import { billingConfig } from "./api";

// Every price on every screen comes from the gateway (GET /billing/config, which reads app/pricing.py): nothing is typed twice.
// Change a number there and the pricing page, the plans screen, checkout, the add-ons tab, prompts and emails all follow.

// $79, $9.99: whole amounts drop the ".00"
export const money = (n) => {
  const v = Math.round(Number(n) * 100) / 100;
  return `$${Number.isInteger(v) ? v : v.toFixed(2)}`;
};

let cached = null;
export function loadPricing() {
  if (!cached) cached = billingConfig().catch((e) => { cached = null; throw e; });
  return cached;
}

export function usePricing() {
  const [cfg, setCfg] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { loadPricing().then(setCfg).catch(setError); }, []);
  return { cfg, error };
}

export const PAID_KEYS = ["naim", "adult", "family"];
// the plan ids the gateway knows them by (the config calls the adult plan "adult" too)
export const planIdOf = (key) => key;

export const foundingOpen = (cfg, now = new Date()) => !!cfg && now <= new Date(cfg.founding.endsAt);
export const savingPercent = (monthly, yearly) => Math.round((100 * (monthly * 12 - yearly)) / (monthly * 12));

// The yearly price a person pays: the founding price while the window is open, or when they hold a founding lock that carries on.
export function yearlyPriceFor(cfg, planKey, { locked = false, now = new Date() } = {}) {
  const p = cfg.plans[planKey];
  return locked || foundingOpen(cfg, now) ? p.foundingYearly : p.yearly;
}

export const foundingEndText = (cfg) =>
  new Date(cfg.founding.endsAt).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "Asia/Singapore" });

export const per = (billing) => (billing === "yearly" ? "year" : billing === "daily" ? "day" : "month");
